import formatDate from "astrid-helpers/src/formatDate";

import articleDeliveryTypes from "./constants/articleDeliveryTypes";
import articlePublicationStatuses from "./constants/articlePublicationStatuses";
import articleStatuses from "./constants/articleStatuses";
import getArticleChannelData from "./getArticleChannelData";

export default function getPublicationStatus({ article, channelId, now = new Date() }) {
	const today = formatDate(now);

	const channelData = article.channels?.[channelId] ?? {};

	const announcementDate = getArticleChannelData(article, channelId, "announcementDate");
	const announcement = announcementDate ? announcementDate : today;
	const releaseDate = getArticleChannelData(article, channelId, "releaseDate");
	const takedownDate = getArticleChannelData(article, channelId, "takedownDate");

	const { delivery = {} } = channelData;

	const metadataSent = !!delivery.metadata?.sent;
	const artifactSent = !!delivery.artifact?.sent; // Mainly only cares about metadataSent, but some channels only deliver files (e.g axiell).

	if (article.status === articleStatuses.DRAFT || (!metadataSent && !artifactSent)) {
		return articlePublicationStatuses.NOT_PUBLISHED;
	}

	const channelIsActive = article.channelIds?.includes(channelId);
	const preventTakedown = article.channels?.[channelId]?.preventTakedown;
	const deliveryTypes = channelData.deliveryTypes ?? [];
	const isArtifactOnly =
		deliveryTypes.includes(articleDeliveryTypes.ARTIFACT) && !deliveryTypes.includes(articleDeliveryTypes.METADATA);

	if (channelIsActive) {
		if (takedownDate) {
			if (today >= takedownDate && takedownDate >= releaseDate && !preventTakedown) {
				return articlePublicationStatuses.UNPUBLISHED;
			}
		}

		if (isArtifactOnly) {
			if (artifactSent && (!releaseDate || today >= releaseDate)) {
				return articlePublicationStatuses.PUBLISHED;
			}
			return articlePublicationStatuses.NOT_PUBLISHED;
		}

		if (releaseDate) {
			if (today >= releaseDate) {
				return articlePublicationStatuses.PUBLISHED;
			}
		}

		if (announcement) {
			if (today >= announcement) {
				return articlePublicationStatuses.ANNOUNCED;
			}
		}
	}

	if (takedownDate) {
		if (today >= takedownDate && !preventTakedown) {
			return articlePublicationStatuses.UNPUBLISHED;
		}
	}

	return articlePublicationStatuses.NOT_PUBLISHED;
}
